<template>
  <ContactModal
    data-test-id="UpgradeModal__baseModal"
    :showModal="showModal"
    title="Request an Upgrade"
    @close="handleClose"
    @onCall="handleOutreachLinkClicked"
    @onEmail="handleEmailButtonClicked"
  />
</template>

<script>
import {
  accountEmail,
  calendlyLink,
  eventProperties,
  upgradeModalProps,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapGetters, mapState } from 'vuex';

import EventHelper from 'client/GrowthEngineering/EventHelper';
import ModalEventBus from 'components/Modal/ModalEventBus';
import Util from 'client/util/Util';

import ContactModal from 'client/components/Modal/ContactModal.vue';

const settingsModule = 'SettingsModule';

export default {
  name: 'UpgradeModal',

  accountEmail,
  calendlyLink,
  ModalEventBus,
  Util,

  components: {
    ContactModal,
  },

  props: {
    calendarUrl: {
      default: () => '',
      type: String,
    },
    eventLocation: {
      type: String,
      default: () => '',
    },
    packageInfo: {
      type: String,
      default: () => '',
    },
    showModal: {
      type: Boolean,
    },
  },

  computed: {
    ...mapGetters(settingsModule, [
      'isProvider',
    ]),

    ...mapState(settingsModule, [
      'orgId',
    ]),
  },

  created() {
    this.emitSegmentEvent({
      description: 'Request Upgrade Modal viewed',
      location: 'Request Upgrade Modal',
      type: 'triggerModalViewed',
      fromUrl: this.$route.path,
    });
  },

  methods: {
    emitSegmentEvent({
      type, description, fromUrl, iconName, section, location, text,
    }) {
      EventHelper[type]({
        [eventProperties.description]: description,
        [eventProperties.fromUrl]: fromUrl,
        [eventProperties.iconName]: iconName,
        [eventProperties.location]: location,
        [eventProperties.section]: section,
        [eventProperties.text]: text,
      });
    },

    handleClose() {
      // Trigger close in case this modal has been
      // loaded using the ModalEventBus.
      ModalEventBus.close();

      this.$emit('close');
      // CAP Request Upgrade Dialogue Box
      this.emitSegmentEvent({
        description: 'Request Upgrade modal is closed',
        iconName: 'close',
        location: `${this.packageInfo} Request Upgrade Dialogue Box`,
        section: upgradeModalProps.upgradeContactSalesModal,
        type: 'triggerIconClicked',
      });
    },

    handleEmailButtonClicked() {
      this.emitSegmentEvent({
        description: 'Contact Sales via Email Button Clicked',
        section: 'middle',
        type: 'triggerButtonClicked',
        text: 'Request Upgrade',
      });
      this.$options.Util.openUrl(`mailto:${accountEmail}?subject=${this.packageInfo || 'JumpCloud'} upgrade request`);
    },

    handleOutreachLinkClicked() {
      this.emitSegmentEvent({
        description: upgradeModalProps.upgradeContactSalesModal,
        location: `${this.packageInfo} Request Upgrade Dialogue Box`,
        section: 'modal',
        type: 'triggerButtonClicked',
      });

      this.$options.Util.openUrl(this.calendarUrl);

      if (!this.isProvider) {
        EventHelper.triggerOutReachLinkClicked({
          modal: upgradeModalProps.upgradeContactSalesModal,
        });
      } else {
        EventHelper.triggerProviderOutreachLinkClicked({
          modal: upgradeModalProps.upgradeContactSalesModal,
        });
      }
    },
  },
};
</script>

<style module scoped>
.buttonContainer {
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
  margin-top: 24px;
}

.center {
  text-align: center;
}

.ctaHeader {
  text-align: left;
}

.ctaWrapper {
  display: flex;
  flex-wrap: wrap;
  gap: var(--jc-spacer);
  justify-content: center;
  margin-bottom: var(--jc-spacer-large);
  padding: 0 var(--jc-spacer-medium);
  text-align: center;
}
</style>
